module.exports = __webpack_public_path__ + "img/bg_xmt.64dfdbed.png";